export type QuillAlignment = 'left' | 'center' | 'right' | 'justify';

export function extractQuillAlignment(html: string | null | undefined): QuillAlignment {
  if (!html) return 'left';
  const match = html.match(/class="ql-align-(\w+)"/);
  const value = match?.[1];
  return value === 'center' || value === 'right' || value === 'justify' ? value : 'left';
}
